import { Container } from "@mui/material";
import { Link, NavLink } from "react-router-dom";

export default function AdminPageLayout({ children }) {
    return <Container maxWidth="lg" className="my-5">
        <h1 className="font-bold text-4xl">Dashboard</h1>
        <br />
        <hr />

        <div className="flex gap-20 pt-5">
            <div className="flex flex-col gap-2 w-[300px]">
                <NavLink activeClassName="active" to="/dashboard/users">Users</NavLink>
                <NavLink activeClassName="active" to="/dashboard/best-practices">Best practices</NavLink>
                <NavLink activeClassName="active" to="/dashboard/approve-url">Approve URL</NavLink>
                <NavLink activeClassName="active" to="/dashboard/news">News</NavLink>
                <NavLink activeClassName="active" to="/dashboard/pages">Pages</NavLink>
                <NavLink activeClassName="active" to="/dashboard/permissions">Permissions</NavLink>
                <NavLink activeClassName="active" to="/dashboard/messages">Messages</NavLink>
                <NavLink activeClassName="active" to="/dashboard/admins">Admins</NavLink>
            </div>
            <div className="w-full ">
            { children }
            </div>
        </div>

    </Container>
}